import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'

function FilterCheckbox({ filter, query, setQuery }) {
  const handleChange = (e) => {
    const value = e.target.checked ? e.target.value : undefined
    const set = new Set(query[filter.name] ? [...query[filter.name]] : [])

    value ? set.add(value) : set.delete(e.target.value)

    setQuery((query) => ({ ...query, [filter.name]: [...set] }))
  }

  return (
    <FormGroup row>
      {filter.items.map(({ label, value, id }, index) => (
        <FormControlLabel
          key={id || label + index}
          control={<Checkbox size="small" onChange={handleChange} />}
          label={label}
          value={value}
          checked={
            (query[filter.name] &&
              query[filter.name].includes(String(value))) ||
            false
          }
        />
      ))}
    </FormGroup>
  )
}

export default FilterCheckbox
